export const SendEmailInvoiceErrorMap: Record<string, string> = {
  'Invoice Service not found!': 'Nota fiscal de serviço não encontrada!',
  'Client not found!': 'Cliente não encontrado!',
  'Client does not have email!': 'Este cliente não possui email cadastrado!',
  'Invoice file not downloaded!': 'Não foi possivel baixar a nota fiscal',
}

export const ExportInvoicesXmlZipErrorMap: Record<string, string> = {
  'Invoice file not downloaded!': 'Não foi possivel baixar a nota fiscal',
}
